import { render, staticRenderFns } from "./lessIndex.vue?vue&type=template&id=f154bd92&scoped=true"
import script from "./lessIndex.vue?vue&type=script&lang=js"
export * from "./lessIndex.vue?vue&type=script&lang=js"
import style0 from "./lessIndex.vue?vue&type=style&index=0&id=f154bd92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f154bd92",
  null
  
)

export default component.exports